import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
  plusMinusContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    height: theme.spacing(5),
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
}));
